import React, { Component } from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';
import withMessages from 'component-utilities/intl';

import ModalContainer from './ModalContainer';
import ModalHeader from './ModalHeader';
import ModalContentLeft from './ModalContentLeft';
import ModalText from './ModalText';
import ModalButtons from './ModalButtons';

import {
    FormContainer,
    FormTitle,
    FormRow,
    FormContent,
    FormItemFull,
    FormLabel,
    InputField,
    Textarea,
} from '../Forms';

import styles from './Modals.scss';

const BASE_KEY = 'components.modals.save_as_new';

// TODO: move this to view-apps-javascript for reuse once view-apps-javascript
// is back to working order on the latest version
function isBlank(str) {
    return !str || str.length === 0 || !/\S/.test(String(str));
}

@withMessages
export default class SaveAsNewModal extends Component {
    static displayName = displayName('Modals/SaveAsNewModal');

    static propTypes = {
        getMessage: PropTypes.func.isRequired,
        onClose: PropTypes.func.isRequired,
        onSave: PropTypes.func.isRequired,
        searchName: PropTypes.string.isRequired,
        searchDescription: PropTypes.string,
    };

    static defaultProps = {
        searchDescription: '',
    };

    constructor(props) {
        super(props);
        this.state = {
            searchName: this.searchNameCopy(),
            searchDescription: props.searchDescription,
            isSaving: false,
        };
    }

    onChange = type => e => this.setState({ [type]: e.target.value });

    getMessage = message => this.props.getMessage(`${BASE_KEY}.${message}`);

    searchNameCopy = () => `${this.props.searchName} - ${this.getMessage('form.copy')}`;

    render() {
        const { onClose, onSave } = this.props;
        const { searchName, searchDescription } = this.state;

        const onSaveClick = () => {
            this.setState({ isSaving: true });
            onSave({ ...this.state });
        };

        return (
            <ModalContainer dataTags={{ 'data-modal': 'save-as-new' }}>
                <ModalHeader onCloseClick={onClose}>
                    {this.getMessage('header')}
                </ModalHeader>

                <ModalContentLeft>
                    <ModalText>
                        {this.getMessage('description')}
                    </ModalText>
                    <FormContainer className={styles['form-container']}>
                        <FormTitle>
                            {this.getMessage('form.title')}
                        </FormTitle>

                        <FormRow>
                            <FormContent>
                                <FormItemFull>
                                    <FormLabel required>
                                        {this.getMessage('form.search_name')}
                                    </FormLabel>
                                    <InputField
                                        data-field="search-name"
                                        value={searchName}
                                        onChange={this.onChange('searchName')}
                                    />
                                </FormItemFull>
                            </FormContent>
                        </FormRow>

                        <FormRow>
                            <FormContent>
                                <FormItemFull>
                                    <FormLabel>
                                        {this.getMessage('form.description')}
                                    </FormLabel>
                                    <Textarea
                                        data-field="search-description"
                                        focused={false}
                                        value={searchDescription}
                                        onChange={this.onChange('searchDescription')}
                                    />
                                </FormItemFull>
                            </FormContent>
                        </FormRow>
                    </FormContainer>
                </ModalContentLeft>

                <ModalButtons
                    onPrimaryClick={onSaveClick}
                    primaryText={this.getMessage('buttons.primary')}
                    primaryDisabled={isBlank(this.state.searchName) || this.state.isSaving}
                    onSecondaryClick={onClose}
                    secondaryText={this.getMessage('buttons.secondary')}
                />
            </ModalContainer>
        );
    }
}
